import { observable, action, computed } from "mobx";
import ActorUtils from "src/utils/ActorUtils";
import HttpUtils from "src/utils/HttpUtils";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class UserStore {
  @observable
  obj_userData = {
    actor: {},
    roles: [],
    version: "",
    build: "",
    environment: "dev",
  };

  @observable
  devUser = !IS_BIRD_APP
    ? localStorage.getItem("devUser") || "michalpazitny"
    : null;

  @observable
  o_all_ecb_users = {
    results: [],
  };

  constructor(http) {
    this.http = http;
    this.changeDevUser(this.devUser);
    this.activate_UserStore(this.fetchAllUsers);
  }

  activate_UserStore = (callback) => this.helper_fetch_UserData(callback);

  @action
  changeDevUser = (selectedDevUser) => {
    this.devUser = selectedDevUser;
    HttpUtils.updateAuthenticatedActorIdHeader(selectedDevUser);
    localStorage.setItem("devUser", selectedDevUser);
  };

  @action
  helper_fetch_UserData = (callback) => {
    this.http.h_service_fetch_user_data().then(
      action((obj_data) => {
        this.obj_userData = obj_data;
        if (callback) {
          callback();
        }

        this.keepLocalStorageUpToDate();
      })
    );
  };

  @action
  keepLocalStorageUpToDate = () => {
    const appVersionFromLS = localStorage.getItem("app-version");
    const realVersion = `${this.version()}/${this.build()}`;

    if (!!appVersionFromLS && appVersionFromLS !== realVersion) {
      localStorage.clear();
    }
    localStorage.setItem("app-version", realVersion);
  };

  @action
  fetchAllUsers = () => {
    if (!IS_BIRD_APP) {
      if (this.isUserDaOrPoOrMao || this.isUserSystemAdministrator) {
        this.http.service_query_all_ecb_user().then((response) => {
          this.o_all_ecb_users = response;
        });
      }
    }
  };

  hasUserTheGivenRole = (role) => {
    return (
      !IS_BIRD_APP &&
      computed(
        () =>
          this.obj_userData.roles.length > 0 &&
          this.obj_userData.roles.includes(role)
      ).get()
    );
  };

  @computed
  get isUserSystemAdministrator() {
    return (
      !IS_BIRD_APP && this.obj_userData.roles.includes("SYSTEM_ADMINISTRATOR")
    );
  }

  @computed
  get isUserDaOrPoOrMao() {
    return (
      !IS_BIRD_APP &&
      (this.obj_userData.roles.includes("DICTIONARY_ADMINISTRATOR") ||
        this.obj_userData.roles.includes("PROJECT_OWNER") ||
        this.obj_userData.roles.includes("MAINTENANCE_AGENCY_OWNER"))
    );
  }

  @computed
  get isUserReaderOnly() {
    return (
      IS_BIRD_APP || (this.obj_userData.roles?.length === 1 && this.obj_userData.roles.includes("READER"))
    );
  }

  version = () => {
    return computed(() => this.obj_userData.version).get();
  };

  build = () => {
    return computed(() => this.obj_userData.build).get();
  };

  environment = () => {
    return computed(() => this.obj_userData.environment).get();
  };

  @computed
  get get_obj_userData() {
    return this.obj_userData;
  }

  @computed
  get getDevUser() {
    return this.devUser;
  }

  @computed
  get http_computed_a_all_ecb_users() {
    if (!this.o_all_ecb_users.results) return [];
    return this.o_all_ecb_users.results.map((user) => {
      return {
        label: ActorUtils.getActorDisplayName(user.name, user.authSystem),
        value: user.tid,
        login: user.login,
        authSystem: user.authSystem,
      };
    });
  }
}
